export const numbersForRentPriceFilter: number[] = [
  0, 100, 200, 300, 400, 500, 1000, 1500, 2000, 3000, 4000, 5000, 7500, 10000,
];
